module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiMobile-19e3e6f78301f5384277b0b15792d550.png";